import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'caq72',
  Description:
    'Here\'s all the online content included with your <strong>Chemistry Exam Practice Workbook</strong>.',
  Credits:
    `<p><strong>Exam Practice Questions:</strong><br>
Contributors: Michael Aicken, Sarah Binns, Mike Dagless, David Paterson, Megan Pollard, Andy Rankin, Sarah Rich and Louise Watkins.<br>
Clipart from Corel&reg;<br>
Illustrations by: Sandy Gardner Artist, email sandy@sandygardner.co.uk<br>
IR spectrum in Unit 3: Section 3 &mdash; Source: NIST Chemistry WebBook (https://webbook.nist.gov/chemistry)
</p>
<p>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</p>`,};